import React from 'react';
import VersionForm from '../components/VersionForm';

const VersionerDetails: React.FC = () => {
  return (
    <div>
      <h1>Version Details</h1>
      <VersionForm />
    </div>
  );
};

export default VersionerDetails;
